var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.321,
    height: 17.302,
    viewBox: "0 0 23.321 17.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    d: "M23.012,46.342,20.4,44.355a.781.781,0,0,0-1.254.622v1.216h-.774V44.964a.781.781,0,0,0-.781-.781H16.031v-2.9a.781.781,0,0,0-.781-.781H12.82v-.829h.654a.781.781,0,1,0,0-1.563H8.426a.781.781,0,1,0,0,1.563h.655V40.5H6.06a.781.781,0,0,0-.781.781v1.525H3.753a.781.781,0,0,0-.781.781v1.787H1.563V43.158a.781.781,0,0,0-1.563,0V51.33a.781.781,0,0,0,1.563,0V49.114H2.972v1.832a.781.781,0,0,0,.781.781H5.718l2.757,3.395a.781.781,0,0,0,.606.289h8.505a.781.781,0,0,0,.781-.781V53.6h.774v1.032a.781.781,0,0,0,1.29.593l2.617-2.243a.782.782,0,0,0,.273-.593V46.964A.782.782,0,0,0,23.012,46.342Z",
    transform: "translate(0 -38.108)",
    fill: "#acacac"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.52a72b0381bad1ff52fb6cc58ddc6c43.svg";
export { ForwardRef as ReactComponent };